import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { makeId } from '../../utils'
import { LinkButton } from '../Buttons'
import { getPrefixLang } from '../../../modules/explorer/app/selectors/lang'

/**
 * A basic select menu
 */
export default function SelectMenu({
  value,
  items,
  ButtonComponent,
  langPrefix,
  onSelect,
  MenuProps,
  ...props
}) {
  // anchor element for managing focus
  const [anchorEl, setAnchorEl] = useState(null)
  // unique id for menu
  const [id] = useState(makeId())
  // handler for menu button click
  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  // handler for menu button close
  const handleClose = () => {
    setAnchorEl(null)
  }
  // handler for menu item select
  const handleSelect = e => {
    onSelect && onSelect(e)
    handleClose()
  }

  return (
    <>
      <ButtonComponent
        aria-controls={id}
        aria-haspopup="true"
        onClick={handleClick}
        {...props}>
        {getPrefixLang(value, langPrefix)}
      </ButtonComponent>
      <Menu
        id={id}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        {...MenuProps}
        // disablePortal={true}
        // anchorOrigin={{
        //   vertical: "top",
        //   horizontal: "center",
        // }}
        // transformOrigin={{
        //   vertical: "bottom",
        //   horizontal: "center",
        // }}
      >
        {items.map(item => {
          return(
            <MenuItem
              key={item}
              selected={item === value}
              onClick={e => handleSelect(item, e)}>
              {getPrefixLang(item, langPrefix) || "Select"}
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}

SelectMenu.defaultProps = {
  ButtonComponent: LinkButton,
  langPrefix: 'LABEL'
}

SelectMenu.propTypes = {
  /** React element to use for the button (default: LinkButton) */
  ButtonComponent: PropTypes.object,
  /** Function that accepts the menu item and returns a label */
  getLabel: PropTypes.func
}
